import { storyboards } from "../images"

export default function StoryboardProjects() {
    return (
      <div className="storyboard-projects-container">
        {
          storyboards.map((project, index) => 
            <div className="SB-project-container" key={index}>
              <img className="SB-title-card" key={project.title} src={project.titleCard} alt={`${project.title} title card`} />
              <div className="SB-Panels">
                {project.images.map((image, i) => <img className="SB-Panel" key={project.title + '-' + i} src={image} alt={`${project.title}-panel-${i}`} />)}
              </div>
            </div>
          )
        }
      </div>
    )
}